export const CANCELLED_WARNING_THRESHOLD = 2;

// The bulk endpoint rejects a batch larger than this outright - management-api
// caps `tenantIds` at MSSP_MIGRATION_MAX_BATCH_SIZE (20 in every environment)
// before any tenant is looked at. Capping the list here means the operator
// cannot build a batch whose only possible outcome is a 400.
export const MAX_SELECTED_CHILDREN = 20;

export interface ChildWorkspace {
  id: string;
  name: string;
  cancelled: boolean;
}

export const isSelectChildrenValid = (
  selectedIds: readonly string[]
): boolean =>
  selectedIds.length > 0 && selectedIds.length <= MAX_SELECTED_CHILDREN;

/** How many of these children can be selected at once - the list may be longer. */
export const selectableCount = (children: readonly ChildWorkspace[]): number =>
  Math.min(children.length, MAX_SELECTED_CHILDREN);

/**
 * The ids Select All should produce: the first MAX_SELECTED_CHILDREN in list
 * order. Truncating rather than refusing keeps the shortcut useful on a parent
 * with more children than one batch can carry.
 */
export const cappedSelection = (
  children: readonly ChildWorkspace[]
): string[] => children.slice(0, MAX_SELECTED_CHILDREN).map(({ id }) => id);

export const countCancelledSelected = (
  children: readonly ChildWorkspace[],
  selectedIds: readonly string[]
): number => {
  const selected = new Set(selectedIds);
  return children.filter(c => selected.has(c.id) && c.cancelled).length;
};

export const getSelectedChildNames = (
  children: readonly ChildWorkspace[],
  selectedIds: readonly string[]
): string[] => {
  const selected = new Set(selectedIds);
  return children.filter(c => selected.has(c.id)).map(c => c.name);
};
